import { DashboardLayout } from "@/projects/components/dashboard-layout";
import { Card } from "@/projects/components/ui/card";
import { useAuth } from "@/projects/lib/useStore";

function Row({ k, v }: { k: string; v: string }) {
  return (
    <div className="flex justify-between border-b py-2">
      <span className="text-muted-foreground">{k}</span>
      <span className="font-medium">{v}</span>
    </div>
  );
}

export function AdminProfilePage() {
  const auth = useAuth();
  const displayName = auth?.name?.trim() || auth?.email || "Admin";
  const initial = (displayName[0] || "A").toUpperCase();
  const email = auth?.email?.trim() || displayName;

  return (
    <DashboardLayout
      role="admin"
      title="Profile"
      breadcrumb={["Home", "Profile"]}
    >
      <Card className="max-w-xl p-6">
        <div className="flex items-center gap-4">
          <div className="grid h-16 w-16 shrink-0 place-items-center rounded-full border-2 border-[#f0c14d]/50 bg-[#0f2a6b] text-xl font-bold text-white shadow-sm">
            {initial}
          </div>
          <div className="min-w-0">
            <div className="text-royal truncate text-lg font-semibold">
              {displayName}
            </div>
            <div className="text-muted-foreground text-sm capitalize">
              {auth?.role ?? "admin"} · {auth?.id ?? "—"}
            </div>
          </div>
        </div>
        <div className="mt-6 grid gap-3 text-sm">
          <Row k="Email" v={email} />
          <Row k="Role" v="Super Admin" />
          <Row k="Event" v="રાજનગર જ્ઞાનોત્સવ 2.0" />
        </div>
      </Card>
    </DashboardLayout>
  );
}
